import { useState } from 'react';
import { Button, Input, Spin, notification } from 'antd';
import { DeleteOutlined, PlusSquareOutlined } from '@ant-design/icons';
const DownloadPiiModal = ({ downloadPII, downloadCC, orderId, type, generateInbound, loading }) => {
    const [api, contextHolder] = notification.useNotification();
    const [emailIds, setEmailIds] = useState(['']);
    const handleChange = (value, i) => {
        const tempEmailIds = emailIds;
        tempEmailIds[i] = value;
        setEmailIds([...tempEmailIds]);
    };
    const AddInputField = () => {
        setEmailIds([...emailIds, '']);
    };
    const removeInpulField = index => {
        const tempEmailIds = emailIds;
        tempEmailIds.splice(index, 1);
        setEmailIds([...tempEmailIds]);
    };
    const handleSubmit = () => {
        const finalArr = emailIds.filter(email => email.trim() !== '');
        const data = {
            orderId,
            emailIds: finalArr,
        };
        if (!finalArr.length)
            return api.info({
                message: 'Please add at least one email',
            });
        if (type === 'pii') {
            downloadPII(data);
        } else if (type === 'inbound') {
            generateInbound({
                orderId,
                toEmailIds: finalArr,
            });
        } else {
            downloadCC(data);
        }
    };
    return (
        <div style={{ position: 'relative' }}>
            {contextHolder}
            {emailIds.map((email, i) => (
                <div key={i} style={{ display: 'flex', margin: '10px 0', gap: '5px' }}>
                    <Input placeholder="Enter your email here" value={email} onChange={e => handleChange(e.target.value, i)} />
                    <Button onClick={() => removeInpulField(i)} styel={{ marginLeft: '5px' }}>
                        <DeleteOutlined />
                    </Button>
                </div>
            ))}
            <Button onClick={AddInputField} style={{ margin: '5px 0' }}>
                <PlusSquareOutlined /> Add Field
            </Button>

            <Button onClick={handleSubmit} style={{ margin: '5px' }} loading={loading} disabled={loading}>
                Submit
            </Button>
        </div>
    );
};

export default DownloadPiiModal;
